import { useMemo } from 'react';

import * as api from '../../api';
import * as logger from '../../logger';

import AddressInput from '../AddressInput';

interface Props {
  id?: string;
  value: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
  previsitAddressValidCharacterSet: api.PracticePreference.PrevisitAddressValidCharacterSet;
}

export function Address(props: Props) {
  const {
    value,
    updateFieldValue,
    saveFieldValue,
    id,
    previsitAddressValidCharacterSet,
  } = props;

  const initialPlace = useMemo(() => {
    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        logger.error(e, 'Error parsing address value');
        return undefined;
      }
    } else {
      return undefined;
    }
  }, [value]);

  const onSave = (place: api.Places.PlaceDetails) => {
    const newValue = JSON.stringify(place);

    updateFieldValue(newValue);
    saveFieldValue(newValue);
  };

  return (
    <AddressInput
      id={id}
      initialPlace={initialPlace}
      onSave={onSave}
      previsitAddressValidCharacterSet={previsitAddressValidCharacterSet}
    />
  );
}
